import { useEffect, useContext } from 'react';
import { GlobalContext } from '../../hooks/globalContext';
import apiCall from '../../utility/api';

interface TroubleshooterDeviceProps {
    data?: any;
    func?: (data: any) => void;
    groupData?: any;
    groupFunc?: (data?: any) => void;
    pageNo?: number;
    overlayOpen?: any;
    isFilter?: any;
    setTotalPages?: (pages?: number) => void;
    setTotalRecords?: (records?: number) => void;
    setGroupName?: (name?: string) => void;
    groupName?: string;
    searchDevVal?: string;
    allDevice?: boolean;
    setallDevice?: (value?: boolean) => void;
    setMachineStatus?: (status?: Record<string, any>) => void;
    filterArray?: string[];
    dropDownValue1?: any;
    setIsFilter?: React.Dispatch<React.SetStateAction<boolean>>;
    dropDownValue2?: any;
    setLoadingDevice?: any;
    isOverlayFilter?: any;
    setIsOverlayFilter?: any;
    overlayFilterArray?: any;
    dropDownValue1Overlay?: any;
    dropDownValue2Overlay?: any;
    setTotalOverlayPages?: any;
    setTotalOverlayRecords?: any;
    setCurrentOverlayPageNo?: any;
    overlayPageNo?: any;
    selectedData?: any;
}

interface ApiResponse {
    status?: string;
    data?: any;
}

interface CensusCountResponse {
    totalRecords?: number;
    totalPages?: number;
}

interface DeviceStatusResponse {
    [key: string]: any;
}

export const TroubleshooterDevice_fun = (props: TroubleshooterDeviceProps) => {
    const contextValue: any = useContext(GlobalContext);

    const tenantName: string = contextValue.tenantName;

    const getDeviceClassificationList = async (whereCondition: Record<string, any>): Promise<void> => {
        const { status, data }: ApiResponse = await apiCall('/groups/getList', { ...whereCondition, limit: null, offset: 0 });
        if (status === 'success' && data) {
            props.groupFunc(data);
            props.setallDevice(true);
        }
    };

    const getTDeviceList = async (whereCondition: Record<string, any>, limit: number, offset: number): Promise<void> => {
        try {
            const { status, data }: ApiResponse = await apiCall('/census/getCensus', { ...whereCondition, limit, offset });
            if (status === 'success') {
                console.log('Census data------=', data);
                props.func(data);
                props.setLoadingDevice(false);
                await getStatusOfdevicesList(tenantName, 'Sites', 'yes');
            }
        } catch (error) {
            console.log('getTDeviceList error=', error);
        }
    };

    const getTDeviceListsCnt = async (whereCondition: Record<string, any>): Promise<void> => {
        try {
            const { status, data }: ApiResponse = await apiCall('/census/getCensusCount', whereCondition);

            if (status === 'success' && (data as CensusCountResponse).totalRecords > 0) {
                props.setTotalOverlayRecords((data as CensusCountResponse).totalRecords);
                props.setTotalOverlayPages((data as CensusCountResponse).totalPages);
            }
        } catch (error) {
            console.log('getCensusListsCnt error=', error);
            // props.setTotalOverlayRecords(0);
            // props.setTotalOverlayPages(1);
        }
    };

    const getStatusOfdevicesList = async (name: string, type: string, deviceStatus: string) => {
        try {
            let { status, data } = await apiCall('/getDeviceStatus', { tenant: name });

            console.log('data=', data);
            if (status === 'success' && data) {
                var statusObj: any = {};

                Object.keys(data)?.map((val: any) => {
                    statusObj[`${val}`] = [data[`${val}`].status === 'online' ? 'online' : 'offline', data[`${val}`].os];
                });

                props?.setMachineStatus(statusObj);
            }
        } catch (error) {
            console.log('getStatusOfdevicesList error=', error);
        }
    };

    useEffect(() => {
        console.log('props.groupName: ', props.groupName);
        if (props.isOverlayFilter === true && props.overlayFilterArray?.length > 0) {
            getTDeviceList(
                { filter: props.overlayFilterArray, tenant: tenantName, classification: props.groupName, type: 'filter' },
                50,
                props.overlayPageNo,
            );
            getTDeviceListsCnt({ filter: props.overlayFilterArray, tenant: tenantName, classification: props.groupName, type: 'filter' });
        } else if (props.searchDevVal?.length > 0 && props.searchDevVal !== '') {
            getTDeviceList({ tenant: tenantName, classification: props.groupName, search: props.searchDevVal, type: 'search' }, 10, props.overlayPageNo);
            getTDeviceListsCnt({ tenant: tenantName, search: props.searchDevVal, type: 'search' });
        } else if (props.allDevice) {
            getTDeviceList({ tenant: tenantName }, 50, props.overlayPageNo);
            getTDeviceListsCnt({ tenant: tenantName });
        } else if (props.groupName?.length > 0 && props.groupName != '') {
            getTDeviceList({ tenant: tenantName, classification: props.groupName }, 10, props.overlayPageNo);
            getTDeviceListsCnt({ tenant: tenantName, classification: props.groupName });
        } else {
            getDeviceClassificationList({ tenant: tenantName });
            getTDeviceListsCnt({ tenant: tenantName });
        }
    }, [props.searchDevVal, props.pageNo, props.groupName, props.allDevice, props.overlayFilterArray, props.isOverlayFilter, props.selectedData]);

    return null;
};
